import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';

import State from './components/State';

ReactDOM.render(<State />, document.getElementById('root'));

